// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
import Swiper from 'swiper/bundle';

$(() => {
  if ($('#top_ai_recommend_spot').length) {
    $.ajax({
      url: '/top_ai_recommend',
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      type: 'GET',
      timeout: 5000,
    });
  }
});

// swiper設定
const topMvElm = document.querySelector('[data-role="top-mv-swiper"]');
if (topMvElm !== null) {
  const totalItems = topMvElm.querySelectorAll('.swiper-slide').length;
  const pagerCurrent = document.querySelector('[data-role="top-mv-nav-pager-current"]');
  const pagerTotal = document.querySelector('[data-role="top-mv-nav-pager-total"]');
  if (pagerTotal) pagerTotal.textContent = totalItems;
  let topMvSwiper = new Swiper('[data-role="top-mv-swiper"]', { // eslint-disable-line no-unused-vars
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1500,
    navigation: {
      nextEl: '[data-role="top-mv-nav-next"]',
      prevEl: '[data-role="top-mv-nav-prev"]',
    },
    pagination: {
      el: "[data-role='top-mv-pagination']",
      clickable: true,
    },
    on: {
      slideChange: function () {
        pagerCurrent.textContent = this.realIndex + 1;
      },
    },
  });
}
const topTopicsElm = document.querySelector('[data-role="top-topics-swiper"]');
if (topTopicsElm !== null) {
  const totalItems = topTopicsElm.querySelectorAll('.swiper-slide').length;
  const pagerCurrent = document.querySelector('[data-role="top-topics-nav-pager-current"]');
  const pagerTotal = document.querySelector('[data-role="top-topics-nav-pager-total"]');
  if (pagerTotal) pagerTotal.textContent = totalItems;
  let topTopicsSwiper = new Swiper('[data-role="top-topics-swiper"]', { // eslint-disable-line no-unused-vars
    slidesPerView: 1.2,
    spaceBetween: 16,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1500,
    breakpoints: {
      1012: {
        slidesPerView: 3.2,
        spaceBetween: 32,
      },
    },
    navigation: {
      nextEl: '[data-role="top-topics-nav-next"]',
      prevEl: '[data-role="top-topics-nav-prev"]',
    },
    pagination: {
      el: "[data-role='top-topics-pagination']",
      clickable: true,
    },
    on: {
      slideChange: function () {
        pagerCurrent.textContent = this.realIndex + 1;
      },
    },
  });
}
if (document.querySelector('[data-role="top-course-swiper"]') !== null) {
  let topCourseSwiper = new Swiper('[data-role="top-course-swiper"]', { // eslint-disable-line no-unused-vars
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1500,
    breakpoints: {
      1012: {
        slidesPerView: 1.25,
        spaceBetween: 60,
      },
    },
    navigation: {
      nextEl: '[data-role="top-course-swiper-next"]',
      prevEl: '[data-role="top-course-swiper-prev"]',
    },
  });
}
